export default [
  {
    word: 'Au Fond',
    type: 'adv.',
    pronunciation: 'of-fawn',
    definition: ['at bottom or to the bottom; thoroughly; in reality; fundamentally.'],
    context: 'She might be, au fond, quite a pleasant woman.'
  },
  {
    word: 'Alacrity',
    type: 'n.',
    pronunciation: 'ə-ˈla-krə-tē',
    definition: ['An eager readiness'],
    context: 'She rose with alacrity and moved away.'
  },
  {
    word: 'Claque',
    type: 'n.',
    pronunciation: 'klak',
    definition: ['A group of sycophantic followers.'],
    context: 'No wonder the loudest applause came from the claque.'
  },
  {
    word: 'Ballyhoo',
    type: 'n.',
    pronunciation: 'ballyhoo',
    definition: ['Clamor or uproar.'],
    context: 'They ann.ced, amid much ballyhoo, that they had made a breakthrough.'
  },
  {
    word: 'Ombrifuge',
    type: 'n.',
    pronunciation: 'OM-bruh-fyoozh',
    definition: ['Something that provides protection from the rain, especially an umbrella.'],
    context:
      'When you are caught in a shower and spot a convenient ombrifuge... should you run to it or walk?'
  },
  {
    word: 'Exemplum',
    type: 'n.',
    pronunciation: 'ig-ZEM-pluhm',
    definition: ['An example or model.'],
    context:
      'The man is a positive exemplum: goodhearted, beloved, and a vital part of his community.'
  },
  {
    word: 'Comestible',
    type: 'n.',
    pronunciation: 'comestible',
    definition: ['An article of food.'],
    context: 'We have brought back some fascinating new comestibles.'
  },
  {
    word: 'Nugatory',
    type: 'adj.',
    pronunciation: 'NOO-guh-tor-ee',
    definition: ['Of little value; trifling.'],
    context: 'It looks like a nugatory technical tweak.'
  },
  {
    word: 'Excursus',
    type: 'n.',
    pronunciation: 'ik-SKUHR-suhs',
    definition: [
      'A detailed discussion about a particular point, especially when added as an appendix.'
    ],
    context: "It may be appropriate to make a short excursus into Hume's examination of miracles.'"
  },
  {
    word: 'Orwellian',
    type: 'adj.',
    pronunciation: 'Or-WEH-lee-uhn',
    definition: [
      'A situation, idea, or societal condition that George Orwell identified as being destructive to the welfare of a free and open society.'
    ],
    context:
      'You may have noticed that the Orwellian dystopia being filmed in Minority Report has a cold, blue feel.'
  },
  {
    word: 'Vulnerary',
    type: 'n.',
    pronunciation: 'VUHL-nuh-rer-ee',
    definition: ['Something used for the healing of wounds.'],
    context:
      'Centaurea scabiosa has been used in traditional herbal healing as either a vulnerary or an emollient.'
  },
  {
    word: 'Soporific',
    type: 'n.',
    pronunciation: 'sop-uh-RIF-ik',
    definition: ['Inducing sleep. Dull or monotonous'],
    context:
      "The professor's boring speech was soporific and had everyone in the audience yawning,'"
  },
  {
    word: 'Festoon',
    type: 'n.',
    pronunciation: 'fe-STOON',
    definition: [
      'A decorative chain or string, of flowers, leaves, ribbons, etc., hanging between two points.'
    ],
    context: 'We festooned the halls with leaves and white lights.'
  },
  {
    word: 'bivouac',
    type: 'n.',
    pronunciation: 'BI-vuh-ak',
    definition: ['A temporary encampment, in the open air, typically without tents or cover.'],
    context: 'He reached alone the summit and a storm forced him to make a bivouac.'
  },
  {
    word: 'Osculate',
    type: 'v.',
    pronunciation: 'OS-kyuh-layt',
    definition: ['To touch or to bring together.'],
    context:
      'Whatever he projected in the nature of an enduring osculation was spoiled as Gladwin dropped the bag to the floor with a crash.'
  },
  {
    word: 'Tellurian',
    type: 'n.',
    pronunciation: 'te-LOOR-ee-uhn',
    definition: ['Relating to or inhabiting Earth.'],
    context:
      'They have been in constant training ever since we left Tellus, and now they can stand as high an acceleration as a weak Tellurian.'
  },
  {
    word: 'Pro rata',
    type: 'adv.',
    pronunciation: 'pro RAY-tuh',
    definition: ['Proportionally.'],
    context:
      'His salary will be adjusted automatically since he will be paid pro rata, on a daily basis, for the work he does.'
  },
  {
    word: 'Acarpous',
    type: 'adj.',
    pronunciation: 'ay-KAHR-puhs',
    definition: ['Not producing fruit; sterile.'],
    context: 'He cut down those acarpous plants.'
  },
  {
    word: 'Pellucid',
    type: 'adj.',
    pronunciation: 'puh-LOO-sid',
    definition: ['Admitting the maximum passage of light.'],
    context: "Even at his worse, he's merely pellucid.'"
  },
  {
    word: 'Gelasin',
    type: 'n.',
    pronunciation: 'EL-uh-sin',
    definition: ['A dimple in the cheek that appears when someone smiles.'],
    context: 'Gelasin is this pretty little dimple.'
  },
  {
    word: 'Dactylography',
    type: 'n.',
    pronunciation: 'dak-tuh-LOG-ruh-fee',
    definition: ['The study of fingerprints as a means of identification.'],
    context:
      'For those who wish to study dactylography, the apparatus is neither complicated nor expensive.'
  },
  {
    word: 'Pogonip',
    type: 'n.',
    pronunciation: 'POG-uh-nip',
    definition: ['A dense winter fog having ice particles.'],
    context: 'The mountains of Nevada appear to be the favorite home of the pogonip.'
  },
  {
    word: 'Gambit',
    type: 'n.',
    pronunciation: 'GAM-bit',
    definition: [
      'An opening in which a minor piece is sacrificed to obtain a strategic advantage.'
    ],
    context: 'Her clever opening gambit gave her an early advantage.'
  },
  {
    word: 'Autotelic',
    type: 'n.',
    pronunciation: 'ah-toh-TEH-lik',
    definition: ['Having a purpose, motivation, or meaning in itself.'],
    context: "Steven's autotelic and monological poem is not permitted to stand alone.'"
  },
  {
    word: 'Basilect',
    type: 'n.',
    pronunciation: 'BAZ/BAS-uh-lekt',
    definition: ['The least prestigious variety of a language.'],
    context:
      'At this time the great majority of people in the community were speakers primarily of this basilect.'
  },
  {
    word: 'Metonymy',
    type: 'n.',
    pronunciation: 'muh-TAHN-uh-mee',
    definition: [
      'A figure of speech in which someone or something is referred to by the name of something associated.' +
        'For example, the use of the word "crown" to refer to "monarchy".'
    ],
    context:
      "When you refer to the film industry as Hollywood, you're using a metonymy by calling one subject a name that equates to it.'"
  },
  {
    word: 'Bident',
    type: 'n.',
    pronunciation: 'BY-duhnt',
    definition: ['A two-pronged instrument, weapon, implement, etc.'],
    context: 'In the Renaissance, the bident became a conventional attribute of Pluto.'
  },
  {
    word: 'Capacious',
    type: 'adj.',
    pronunciation: 'kuh-PAY-shuhs',
    definition: ['Having a lot of space; roomy.'],
    context:
      'The harbor is capacious and secure, with sufficient depth of water for the largest vessels.'
  },
  {
    word: 'Gazump',
    type: 'n.',
    pronunciation: 'guh-ZUHMP',
    definition: ['To raise the price after accepting an offer from a buyer.'],
    context: 'In France you cannot be gazumped.'
  },
  {
    word: 'hypogeusia',
    type: 'n.',
    pronunciation: 'hy-puh-GOO/GYOO-zee/zhee-uh',
    definition: ['A diminished sense of taste.'],
    context:
      'True ageusia is relatively rare compared to hypogeusia - a parital loss of taste - and dysgeusia - a distortion or alteration of taste.'
  },
  {
    word: 'Sanguinolency',
    type: 'adj.',
    pronunciation: 'sang-GWIN-uh-len-see',
    definition: ['Addiction to bloodshed.'],
    context: "His advisors' sanguinolency has produced a climate of lethophobia.'"
  },
  {
    word: 'Nebulous',
    type: 'adj.',
    pronunciation: 'neb-u-lous ',
    definition: ['In the form of a cloud or haze; hazy.'],
    context: 'The plan is too nebulous.'
  },
  {
    word: 'Crepuscular ',
    type: 'adj.',
    pronunciation: 'krih-PUHSS-kyuh-ler',
    definition: ['Relating to, or resembling twilight.'],
    context: 'As evening came on, fireflies began to appear in the crepuscular gloaming.'
  },
  {
    word: 'Carceral',
    type: 'adj.',
    pronunciation: 'KAHR-suh-rul',
    definition: ['Relating to, or suggesting a jail or prison.'],
    context: 'The room was eerily quiet and had a carceral aesthetic.'
  },
  {
    word: 'Dilatory',
    type: 'adj.',
    pronunciation: 'DILL-uh-tor-ee',
    definition: ['Tending or intended to cause delay.'],
    context: "The councilor's seemingly endless motions to adjourn were clearly dilatory."
  },
  {
    word: 'Zoomorphic',
    type: 'adj.',
    pronunciation: 'zoh-uh-MOR-fik',
    definition: ['Having the form of an animal.'],
    context: 'Using cookie cutters, the children made zoomorphic treats to bring to the bake sale.'
  },
  {
    word: 'Funambulism',
    type: 'n.',
    pronunciation: 'fyoo-NAM-buh-liz-um',
    definition: ['A show of mental agility.'],
    context:
      'The game-show contestant amazed the audience with her funambulism, answering every question correctly.'
  },
  {
    word: 'Mettlesome',
    type: 'adj.',
    pronunciation: 'MET-ul-sum',
    definition: ['Full of vigor and strength of spirit or temperament.'],
    context: 'The rider was experienced and had no trouble handling the mettlesome horse.'
  },
  {
    word: 'Exculpate',
    type: 'v.',
    pronunciation: 'EK-skull-payt',
    definition: ['To clear from alleged fault or guilt.'],
    context:
      'The lawyer claimed to have recently discovered evidence that would exculpate her client.'
  },
  {
    word: 'Kibosh',
    type: 'n.',
    pronunciation: 'KYE-bosh',
    definition: [
      'It refers to something that serves as a check or stop. It is usually used in the phrase "put the kibosh on."'
    ],
    context: 'The rain put the kibosh on the Fourth of July fireworks display.'
  },
  {
    word: 'Nonpareil',
    type: 'adj.',
    pronunciation: 'nahn-puh-REL',
    definition: ['Having no equal.'],
    context: "The singer's stunning performance was nonpareil."
  },
  {
    word: 'Turpitude',
    type: 'n.',
    pronunciation: 'TER-puh-tood',
    definition: [
      'It refers to inherent lack of integrity or morality, or to an evil or immoral act.'
    ],
    context: 'Crimes such as theft and perjury may involve moral turpitude.'
  },
  {
    word: 'Sagacious',
    type: 'adj.',
    pronunciation: 'suh-GAY-shus',
    definition: [
      'Having or showing an ability to understand difficult ideas and situations and to make good decisions.'
    ],
    context:
      'Student reviews paint the writing professor as a sagacious mentor and a compassionate teacher.'
  },
  {
    word: 'Abeyance',
    type: 'n.',
    pronunciation: 'uh-BAY-unss',
    definition: ['A state of temporary inactivity.'],
    context:
      'The misdemeanor charges are in abeyance while the suspect is being prosecuted for the felony.'
  },
  {
    word: 'Adulation',
    type: 'n.',
    pronunciation: 'aj-uh-LAY-shun',
    definition: ['Extreme or excessive admiration or flattery.'],
    context:
      'The movie star basked in the adulation of her many fans as she walked down the red carpet.'
  },
  {
    word: 'Brouhaha',
    type: 'n.',
    pronunciation: 'BROO-hah-hah',
    definition: [
      "It's a synonym of both uproar and hubbub, and can mean 'a noisy confusion of sound' or 'state of commotion.'"
    ],
    context:
      'A brouhaha erupted over the bill, even though the opposing party stood to gain just as much from its passage.'
  },
  {
    word: 'Recidivism',
    type: 'n.',
    pronunciation: 'rih-SID-uh-viz-um',
    definition: [
      'A relapse into criminal behavior, or more broadly, a tendency to relapse into a previous condition or mode of behavior.'
    ],
    context: "The county's new program has been very successful in reducing recidivism rates."
  },
  {
    word: 'Apposite',
    type: 'adj.',
    pronunciation: 'AP-uh-zit',
    definition: [
      'It is used to describe what is very appropriate, or what is suitable for an occasion or situation. It is a synonym of apt.'
    ],
    context:
      "Before sending the final draft of his novel to his editor, Lyle searched for an apposite quotation that could serve as the book's epigraph."
  },
  {
    word: 'Immutable',
    type: 'adj.',
    pronunciation: 'ih-MYOO-tuh-bul',
    definition: ['Not capable of or susceptible to change.'],
    context:
      'It is hardly an immutable fact that cats and dogs are sworn enemies; over the years our golden retriever has grown both fond and protective of her tabby housemate.'
  },
  {
    word: 'Lugubrious',
    type: 'adj.',
    pronunciation: 'loo-GOO-bree-us',
    definition: ['AMournful or dismal.'],
    context: 'The lugubrious musical passages made audience members teary-eyed.'
  },
  {
    word: 'Obsequious',
    type: 'adj.',
    pronunciation: 'ub-SEE-kwee-us',
    definition: [
      'Marked by or showing a fawning attentiveness, in other words, too eager to help or obey someone important.'
    ],
    context: "The director's crew included an entourage of obsequious film interns."
  },
  {
    word: 'Compendious',
    type: 'adj.',
    pronunciation: 'kum-PEN-dee-us',
    definition: ['Concise or comprehensive.'],
    context: 'The book is fairly short and provides a compendious account of the war.'
  },
  {
    word: 'Askance',
    type: 'adv.',
    pronunciation: 'uh-SKANSS',
    definition: ['With disapproval or distrust.'],
    context:
      'The children looked askance at their mother when she suggested they turn off their electronic devices and go play outside in the nice weather.'
  },
  {
    word: 'Simulacrum',
    type: 'n.',
    pronunciation: 'sim-yuh-LAK-rum',
    definition: ['A superficial likeness or representation of something.'],
    context: 'The wax figure is a perfect simulacrum of the president.'
  },
  {
    word: 'imprimatur',
    type: 'n.',
    pronunciation: 'im-pruh-MAH-toor',
    definition: ['An official approval.'],
    context: 'The governor gave his imprimatur to the proposed reforms.'
  },
  {
    word: 'Polyglot',
    type: 'adj.',
    pronunciation: 'PAH-lee-glaht',
    definition: ['Knowing or using several languages, being multilingual. '],
    context: 'The city has a polyglot community made up of many cultures.'
  },
  {
    word: 'Vanguard',
    type: 'n.',
    pronunciation: 'VAN-gahrd',
    definition: ['The forefront of an action or movement.'],
    context: 'The manufacturer is in the vanguard of green technology.'
  },
  {
    word: 'Peremptory',
    type: 'adj.',
    pronunciation: 'puh-REMP-tuh-ree',
    definition: ['Expressive of urgency or command.'],
    context: 'The soldiers were given a peremptory order to abandon the mission.'
  },
  {
    word: 'Billet-doux',
    type: 'n.',
    pronunciation: 'bill-ee-DOO',
    definition: ['A love letter.'],
    context:
      'While helping her grandmother pack, Abbie came across a billet-doux from her grandfather that was written when the two were teenagers.'
  },
  {
    word: 'Captious',
    type: 'adj.',
    pronunciation: 'KAP-shuss',
    definition: ['Tending to find fault and raise objections.'],
    context:
      'Befuddled by the captious questions, the suspect broke down and confessed to the crime.'
  },
  {
    word: 'Meritorious',
    type: 'adj.',
    pronunciation: 'mair-uh-TOR-ee-us',
    definition: ['Deserving of honor or esteem.'],
    context:
      "At the gathering, the company's president expressed his gratitude to employees for their meritorious service."
  },
  {
    word: 'Opine',
    type: 'v.',
    pronunciation: 'oh-PYNE',
    definition: ['To express an opinion.'],
    context:
      'The writer opines that the town library should be open for longer hours during the summer months. '
  },
  {
    word: 'Ziggurat',
    type: 'n.',
    pronunciation: 'ZIG-uh-rat',
    definition: [
      'An ancient Mesopotamian temple that resembles a pyramid having successive stages with outside staircases and a shrine at the top. The word is used figuratively for any structure having stages or steps.'
    ],
    context: 'The tourists stared with awe at the ancient ziggurat.'
  },
  {
    word: 'Intemperate',
    type: 'adj.',
    pronunciation: 'in-TEM-puh-rut',
    definition: [
      'Having extreme conditions or having or showing a lack of emotional calmness or control.'
    ],
    context: 'The plant is able to survive in intemperate climates.'
  },
  {
    word: 'Commodious',
    type: 'adj.',
    pronunciation: 'kuh-MOH-dee-us',
    definition: ['Comfortably or conveniently spacious.'],
    context:
      'The description of the house for sale notes a commodious living room adjacent to a large kitchen, both perfect for entertaining guests.'
  },
  {
    word: 'Milquetoast',
    type: 'n.',
    pronunciation: 'milque-​toast ',
    definition: ['A timid, meek, or unassertive person.'],
    context:
      'The sales manager is not a milquetoast: when she sees an opportunity to make a lucrative deal, she will seal it.'
  },
  {
    word: 'Rankle',
    type: 'v.',
    pronunciation: 'RANK-ul',
    definition: ['To cause anger, irritation, or bitterness.'],
    context:
      "Rae Ann's snooty attitude and rude behavior rankled the host, but he smiled to hide his irritation."
  },
  {
    word: 'Beleaguer',
    type: 'v.',
    pronunciation: 'bih-LEE-gur',
    definition: ['To trouble or harass.'],
    context:
      'The coach, beleaguered by the media and fans for his poor decision-making during games, has been fired.'
  },
  {
    word: 'Adventitious',
    type: 'adj.',
    pronunciation: 'JOO-buh-layt',
    definition: ['To feel joy or great delight.'],
    context:
      'Supporters of the mayoral candidate jubilated when his victory was officially ann.ced.'
  },
  {
    word: 'Jubilate',
    type: 'v.',
    pronunciation: 'sang-GWIN-uh-len-see',
    definition: ['Addiction to bloodshed.'],
    context: "His advisors' sanguinolency has produced a climate of lethophobia.'"
  },
  {
    word: 'Vestige',
    type: 'n.',
    pronunciation: 'VESS-tij',
    definition: ['A trace, mark, or visible sign left by something lost or vanished.'],
    context: 'The seconds ticked by, but the team still had a vestige of hope.'
  },
  {
    word: 'Adroit',
    type: 'adj.',
    pronunciation: 'uh-DROYT',
    definition: ['Having or showing skill, cleverness, or resourcefulness in handling situations.'],
    context:
      "The CEO has been praised for his adroit management of the company's financial recovery."
  },
  {
    word: 'Intransigent',
    type: 'adj.',
    pronunciation: 'in-TRAN-suh-junt',
    definition: [
      'Characterized by refusal to compromise or to abandon an extreme position or attitude.'
    ],
    context:
      "Despite the mediator's best efforts, the opposing sides in the dispute remained intransigent."
  },
  {
    word: 'Gossamer',
    type: 'adj.',
    pronunciation: 'GAH-suh-mer',
    definition: ['Extremely light, delicate, or tenuous.'],
    context: 'Except for a few gossamer clouds, the sky was clear and blue.'
  },
  {
    word: 'Zaftig',
    type: 'adj.',
    pronunciation: 'ZAHF-tig',
    definition: ['Having a full, rounded figure.'],
    context: "Portraits of zaftig models are exhibited in the artist's collection."
  },
  {
    word: 'Regnant',
    type: 'adj.',
    pronunciation: 'REG-nunt',
    definition: ['Reigning or dominant.'],
    context: 'The regnant kings commanded their armies in the battle.'
  },
  {
    word: 'Gasconade',
    type: 'n.',
    pronunciation: 'gas-kuh-NAYD',
    definition: ['Confident talk or behavior that is intended to impress other people.'],
    context:
      "After all his gasconade, the contestant couldn't manage to complete the obstacle race."
  },
  {
    word: 'Suborn',
    type: 'v.',
    pronunciation: 'suh-BORN',
    definition: [
      'To persuade (someone) to do something illegal (such as to lie in a court of law).'
    ],
    context: 'The lawyer attempted to suborn the witness.'
  },
  {
    word: 'Brogue',
    type: 'n.',
    pronunciation: 'BROHG',
    definition: ['A low shoe, usually made of leather, with perforations and a wing tip.'],
    context: 'Even though his brogues are scuffed and old, Dad prefers them to his new loafers.'
  },
  {
    word: 'Fulminate',
    type: 'v.',
    pronunciation: 'FULL-muh-nayt',
    definition: ['To send forth harsh criticisms or insults.'],
    context:
      'The writer of the editorial fulminated against the corruption in the state government that has been recently uncovered.'
  },
  {
    word: 'Inchoate',
    type: 'adj.',
    pronunciation: 'in-KOH-ut',
    definition: ['Imperfectly formed or formulated.'],
    context:
      'In the podcast, the author described the process by which she took a series of inchoate vignettes and shaped them into her best-selling novel.'
  },
  {
    word: 'Flehmen',
    type: 'n.',
    pronunciation: 'FLAY-mun',
    definition: [
      'A mammalian behavior (as of horses or cats) in which the animal inhales with the mouth open and upper lip curled.'
    ],
    context:
      'The vet explained that what appeared to be a display of anger in the cat was called flehmen.'
  },
  {
    word: 'Misbegotten',
    type: 'adj.',
    pronunciation: 'miss-bih-GAH-tun',
    definition: ['Ill-conceived.'],
    context: "The celebrity's misbegotten tweet went viral. "
  },
  {
    word: 'Filial',
    type: 'adj.',
    pronunciation: 'FIL-ee-ul',
    definition: ["Of, relating to, or befitting a person's child."],
    context:
      "Margaret's sense of filial responsibility is only part of her motivation for carrying on her parents' business; she also loves the work."
  },
  {
    word: 'Pulchritude',
    type: 'n.',
    pronunciation: 'PUHL-kruh-tood',
    definition: ['Physical comeliness'],
    context:
      'The magazine features a photo essay of celebrities who are famed for their Hollywood stardom and pulchritude.'
  },
  {
    word: 'Flexuous',
    type: 'adj.',
    pronunciation: 'FLEK-shuh-wus',
    definition: ['Having curves, turns, or windings.'],
    context:
      'The last leg of the trail is a flexuous path leading up the mountain to a spectacular panoramic view of the valley.'
  },
  {
    word: 'Nimrod',
    type: 'n.',
    pronunciation: 'NIM-rahd',
    definition: ['An idiot or jerk. '],
    context:
      'The stereotypical cast for the film-within-the-film cleverly overacts and paints their obnoxious characters as helpless nimrods.'
  },
  {
    word: 'Undulant',
    type: 'adj.',
    pronunciation: 'UN-juh-lunt',
    definition: ['The rise and fall of waves, or things that move or have a form like waves.'],
    context: 'We followed the undulant green hills on our journey to the resort.'
  },
  {
    word: 'Defenestration',
    type: 'n.',
    pronunciation: 'dee-fen-uh-STRAY-shun',
    definition: ['A throwing of a person or thing out of a window.'],
    context:
      "Michael's annoyance at his alarm clock's persistent drone led to its sudden defenestration from his eighth-floor bedroom."
  },
  {
    word: 'Winnow',
    type: 'v.',
    pronunciation: 'WIN-oh',
    definition: ['To remove people or things that are less important or desirable.'],
    context:
      'The search committee is finding it extremely difficult to winnow the list of job candidates; many of them are highly qualified.'
  },
  {
    word: 'Sophistry',
    type: 'n.',
    pronunciation: 'SAH-fuh-stree',
    definition: ['Reasoning or arguments that sound correct but which are actually false.'],
    context:
      "The professor challenged the student's arguments, insisting they were based on sophistry and could be easily disproven."
  },
  {
    word: 'Liminal',
    type: 'adj.',
    pronunciation: 'LIM-uh-nul',
    definition: [
      'It is used to describe something that is barely perceptible or that involves a transitional or in-between state.'
    ],
    context:
      'The essay presents an image of the border region as a liminal zone where one culture blends into another.'
  },
  {
    word: 'Ossify',
    type: 'v.',
    pronunciation: 'AH-suh-fye',
    definition: ['To make or become hardened and opposed to change.'],
    context: 'Her opinions have ossified.'
  },
  {
    word: 'Desultory',
    type: 'adj.',
    pronunciation: 'DEH-sul-tor-ee',
    definition: ['Marked by lack of definite plan or purpose.'],
    context: 'After graduation, he moved from job to job in a desultory manner.'
  }
]
